// Create mode. The select element ids match the Orders details form so the
// same AG -> Product Type -> Product dropdown flow and services apply.
export const QuoteDetailsFieldsJSON = {
  "1718616984561-customSelect": {
    elementid: 1718616984561,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "ag_id",
    "display-fieldlabel": "AG",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "database-label": "rm_name",
    "display-fieldlabel": "Relationship Manager",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718616994627-customSelect": {
    elementid: 1718616994627,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "SINGLE#CLUBBED",
    "database-label": "product_type",
    "display-fieldlabel": "Product Type",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718617002793-customSelect": {
    elementid: 1718617002793,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "product_id",
    "display-fieldlabel": "Product",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
};

// Edit mode: read-only text fields bound to the saved quote entity.
export const QuoteEditDetailsFieldsJSON = {
  "1718616984561-textfield": {
    elementid: 1718616984561,
    elementtype: "textfield",
    "database-label": "ag_name",
    "display-fieldlabel": "AG",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "database-label": "rm_name",
    "display-fieldlabel": "Relationship Manager",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718616994627-textfield": {
    elementid: 1718616994627,
    elementtype: "textfield",
    "database-label": "product_type",
    "display-fieldlabel": "Product Type",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718617002793-textfield": {
    elementid: 1718617002793,
    elementtype: "textfield",
    "database-label": "product_name",
    "display-fieldlabel": "Product",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
};
